export default __webpack_public_path__ + "4fb3591b15c08deeb52900af1c7688b7.png";